import { useLocation, Navigate } from 'react-router-dom';
import { SHOP_DOMAIN_MAP } from './config/constants';

/**
 * When user visits "/" on a shop domain, redirect to LIFF.
 * Admin stays on smile-shipping-front; shop domains go to /liff.
 */
const ShopDomainRedirect = ({ children }) => {
  const location = useLocation();
  const hostname = typeof window !== 'undefined' ? window.location.hostname : '';

  if (location.pathname !== '/') return children;

  for (const { hosts } of SHOP_DOMAIN_MAP) {
    if (hosts.includes(hostname)) return <Navigate to="/liff" replace />;
  }

  return children;
};

export default ShopDomainRedirect;
